import { Direction, ImageSize, ReduxState, TextDirection } from 'interface';
import React, { useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { SLPEndPageType } from './endPage.interface';
import './endPage.style.scss';
import HintText from 'utilities/slp/hintText/hintText.index';

const SLPEndPage: React.FC<ConnectedProps<typeof connector> & SLPEndPageType> = function (
    props: ConnectedProps<typeof connector> & SLPEndPageType,
) {
    const lang = props.lang.SLP;
    const form = props.form;

    useEffect(() => {
        setTimeout(props.startAgain, (props.form.reset_sec_time ?? 5) * 1000);
    }, []);

    return (
        <div
            className="ucheck-slp-end"
            style={{
                backgroundImage: `url(${
                    form.last_page_bg_file
                        ? form.last_page_bg_file?.file
                        : form.background_image_file
                        ? form.background_image_file.file
                        : form.background_color
                        ? ''
                        : undefined
                }`,
                backgroundColor: form.background_color,
            }}
        >
            <div className="slp-end-page-container">
                <div>
                    {form.logo_last_page_file ? (
                        <img
                            className={
                                form.logo_first_page_size === ImageSize.small
                                    ? 'small'
                                    : form.logo_first_page_size === ImageSize.medium
                                    ? 'medium'
                                    : ''
                            }
                            src={form.logo_last_page_file?.file}
                            alt={form.logo_last_page_file?.alt}
                        />
                    ) : null}
                    <h3>
                        {form.last_page_title
                            ? form.last_page_title
                            : form.subscription?.default && !form.end_page_changed
                            ? lang.tanks
                            : form.title}
                    </h3>
                    <div className="hint-box">
                        <HintText value={props.form.last_page_description} />
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    direction: state.direction,
    isAuth: state.authStatus,
    lang: state.lang,
});

const connector = connect(mapStateToProps);
export default connector(SLPEndPage);
